import { useGetNoteQuery } from '@entities/clients/rtk-query.ts';
import { useNoteActions } from '@entities/note/hooks/useNoteActions';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useClientNoteEditPageRedirect } from '@pages/clients/note/helpers.ts';
import { DescriptionEditor } from '@widgets/shared/descriptionEditor/index.tsx';
import { ArrowShortLeft } from '@shared/assets';
import { IconButton, ListBody, PageHead, PageTitle, TextButton } from '@shared/ui';
import { Loader } from '@src/library/components/common';
import descriptionEditorStyles from '@src/pages/common/descriptionEditorPage/styles.module.scss';

export const NoteEdit: React.FC = () => {
  const { createNoteRecord, updateNoteRecord } = useNoteActions();
  const location = useLocation();
  const { noteId } = useParams();
  const [value, setValue] = useState('');

  const {
    data: note,
    isLoading,
    isFetching,
  } = useGetNoteQuery(Number(noteId), { skip: !noteId || noteId === 'new' });

  const { doRedirectOnPrevPage } = useClientNoteEditPageRedirect();
  const isAddPage = location.pathname.split('/').at(-1) === 'new';
  const titleName = isAddPage ? 'Новая заметка' : 'Редактирование заметки';

  useEffect(() => {
    if (noteId && note) {
      setValue(note.content);
    }
  }, [noteId, note]);

  const handleClickBack = () => {
    doRedirectOnPrevPage(noteId ? `/clients/clients/note/view/${noteId}` : `/clients/clients`);
  };

  const handleClickSubmit = async () => {
    if (isAddPage && value) {
      await createNoteRecord(value);
    } else if (noteId && value) {
      handleClickBack();
      await updateNoteRecord(Number(noteId), value);
    }
  };

  return (
    <>
      <PageTitle title={titleName} />
      <PageHead
        scrollHeaderClassName={descriptionEditorStyles.scrollHeader}
        containerClassName={descriptionEditorStyles.pageHeadContainer}
        Left={
          <IconButton variant="dark" onClick={handleClickBack} title="Вернуться назад">
            <ArrowShortLeft />
          </IconButton>
        }
        Right={
          <TextButton type="button" onClick={handleClickSubmit}>
            Готово
          </TextButton>
        }
      />
      <ListBody className={descriptionEditorStyles.main}>
        {isLoading || isFetching ? (
          <Loader />
        ) : (
          <DescriptionEditor value={value} onChange={setValue} />
        )}
      </ListBody>
    </>
  );
};
